/* eslint-disable */
import React, {useState} from 'react';
//import {useNavigate} from 'react-router-dom';
import 'contents/assets/scss/page/student.scss';
function MentorReport() {
  return (
    <main className="com_container p_satisfaction_manage">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu1_16">
            만족도 설문조사<span className="bar"></span>
            <span className="point_txt">설문조사 관리</span>
          </h2>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <table className="com_board_list">
              <colgroup>
                <col width="60" />
                <col width="60" />
                <col width="100" />
                <col width="auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th rowSpan={2}>
                    <input type="checkbox" id="chk01" className="com_chk" />
                    <label htmlFor="chk01"></label>
                  </th>
                  <th rowSpan={2}>1</th>
                  <td>질문</td>
                  <td>
                    <input type="text" className="input" />
                  </td>
                </tr>
                <tr>
                  <td>답변</td>
                  <td className="td_left">
                    <div className="com_input_wrap">
                      <div className="check com_radio_wrap">
                        <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                        <label htmlFor="rdo01">주관식</label>
                        <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                        <label htmlFor="rdo02">객관식</label>
                      </div>
                    </div>
                    <div className="com_input_wrap flex_row gap">
                      <div className="input_remove_wrap">
                        <span className="tit">1.</span>
                        <input type="text" className="input" />
                        <button className="btn_close_x"></button>
                      </div>
                      <div className="input_remove_wrap">
                        <span className="tit">2.</span>
                        <input type="text" className="input" />
                        <button className="btn_close_x"></button>
                      </div>
                      <div className="input_remove_wrap">
                        <span className="tit">3.</span>
                        <input type="text" className="input" />
                        <button className="btn_close_x"></button>
                      </div>
                      <div className="input_remove_wrap">
                        <span className="tit">4.</span>
                        <input type="text" className="input" />
                        <button className="btn_close_x"></button>
                      </div>
                      <button className="com_btn gray xs">+추가</button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th rowSpan={2}>
                    <input type="checkbox" id="chk01" className="com_chk" />
                    <label htmlFor="chk01"></label>
                  </th>
                  <th rowSpan={2}>2</th>
                  <td>질문</td>
                  <td>
                    <input type="text" className="input" />
                  </td>
                </tr>
                <tr>
                  <td>답변</td>
                  <td className="td_left">
                    <div className="com_input_wrap">
                      <div className="check com_radio_wrap">
                        <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                        <label htmlFor="rdo01">주관식</label>
                        <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                        <label htmlFor="rdo02">객관식</label>
                      </div>
                    </div>
                    <div className="com_input_wrap flex_row gap">
                      <div className="input_remove_wrap">
                        <span className="tit">1.</span>
                        <input type="text" className="input" />
                        <button className="btn_close_x"></button>
                      </div>
                      <div className="input_remove_wrap">
                        <span className="tit">2.</span>
                        <input type="text" className="input" />
                        <button className="btn_close_x"></button>
                      </div>
                      <div className="input_remove_wrap">
                        <span className="tit">3.</span>
                        <input type="text" className="input" />
                        <button className="btn_close_x"></button>
                      </div>
                      <div className="input_remove_wrap">
                        <span className="tit">4.</span>
                        <input type="text" className="input" />
                        <button className="btn_close_x"></button>
                      </div>
                      <button className="com_btn gray xs">+추가</button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th rowSpan={2}>
                    <input type="checkbox" id="chk01" className="com_chk" />
                    <label htmlFor="chk01"></label>
                  </th>
                  <th rowSpan={2}>3</th>
                  <td>질문</td>
                  <td>
                    <input type="text" className="input" />
                  </td>
                </tr>
                <tr>
                  <td>답변</td>
                  <td className="td_left">
                    <div className="com_input_wrap">
                      <div className="check com_radio_wrap">
                        <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                        <label htmlFor="rdo01">주관식</label>
                        <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                        <label htmlFor="rdo02">객관식</label>
                      </div>
                    </div>
                    <div className="com_input_wrap flex_row gap">
                      <div className="input_remove_wrap">
                        <span className="tit">1.</span>
                        <input type="text" className="input" />
                        <button className="btn_close_x"></button>
                      </div>
                      <div className="input_remove_wrap">
                        <span className="tit">2.</span>
                        <input type="text" className="input" />
                        <button className="btn_close_x"></button>
                      </div>
                      <div className="input_remove_wrap">
                        <span className="tit">3.</span>
                        <input type="text" className="input" />
                        <button className="btn_close_x"></button>
                      </div>
                      <div className="input_remove_wrap">
                        <span className="tit">4.</span>
                        <input type="text" className="input" />
                        <button className="btn_close_x"></button>
                      </div>
                      <button className="com_btn gray xs">+추가</button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th rowSpan={2}>
                    <input type="checkbox" id="chk01" className="com_chk" />
                    <label htmlFor="chk01"></label>
                  </th>
                  <th rowSpan={2}>4</th>
                  <td>질문</td>
                  <td>
                    <input type="text" className="input" />
                  </td>
                </tr>
                <tr>
                  <td>답변</td>
                  <td className="td_left">
                    <div className="com_input_wrap">
                      <div className="check com_radio_wrap">
                        <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                        <label htmlFor="rdo01">주관식</label>
                        <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                        <label htmlFor="rdo02">객관식</label>
                      </div>
                    </div>
                    <div className="com_input_wrap flex_row gap">
                      <div className="input_remove_wrap">
                        <span className="tit">1.</span>
                        <input type="text" className="input" />
                        <button className="btn_close_x"></button>
                      </div>
                      <div className="input_remove_wrap">
                        <span className="tit">2.</span>
                        <input type="text" className="input" />
                        <button className="btn_close_x"></button>
                      </div>
                      <div className="input_remove_wrap">
                        <span className="tit">3.</span>
                        <input type="text" className="input" />
                        <button className="btn_close_x"></button>
                      </div>
                      <div className="input_remove_wrap">
                        <span className="tit">4.</span>
                        <input type="text" className="input" />
                        <button className="btn_close_x"></button>
                      </div>
                      <button className="com_btn gray xs">+추가</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="com_btn_wrap between bottom">
              <button className="com_btn gray xs">+ 선택 문항 삭제</button>
              <button className="com_btn gray xs">+ 문항 추가</button>
            </div>
            <hr className="com_divider" />
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange s">저장</button>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
}

export default MentorReport;
